import { AxiosResponse } from 'axios';
import { parseError } from '@/features/common/helpers/errorParser';
import { useAxios } from '@/features/common/helpers/axios';
import { GlobalResponseType } from '@/features/common/types';
import i18n from '@/i18n';
import { CarrierAccountResponseType } from '@/features/carrier-accounts/services/carrierAccounts.services';

export const { axiosService, baseURL } = useAxios();

const filterExceptionMessage = (err: GlobalResponseType): GlobalResponseType => {
  if (!err.errorType) return err;

  const messageKey = `apiKeys.errorMessages.${err.errorType}`;
  if (!i18n.te(messageKey)) return err;

  return {
    ...err,
    errorMessage: i18n.t(messageKey) as string,
  };
};

export const registerCPCMerchant = async (): Promise<{
  returnUrl?: string
} & GlobalResponseType> => {
  try {
    const response: AxiosResponse = await axiosService.get('/my-accounts/cpc-merchant-registration-url?returnUrl=/ship/connect/carrier-accounts/cpc');

    return {
      successful: true,
      errorMessage: '',
      redirectUrl: '',
      returnUrl: response.data,
    };
  } catch (err) {
    return filterExceptionMessage(parseError(err));
  }
};

export const addCPCMerchantAccount = async (
  token: string,
): Promise<{
  data?: CarrierAccountResponseType
} & GlobalResponseType> => {
  try {
    const response: AxiosResponse = await axiosService.post(`/my-accounts/cpc-merchant-registration/${token}`);

    return {
      successful: true,
      errorMessage: '',
      redirectUrl: '',
      data: response.data,
    };
  } catch (err) {
    return filterExceptionMessage(parseError(err));
  }
};

export const registerUPSMerchant = async (): Promise<{
  returnUrl?: string
} & GlobalResponseType> => {
  try {
    const response: AxiosResponse = await axiosService.get('/my-accounts/ups-merchant-registration-url');

    return {
      successful: true,
      errorMessage: '',
      redirectUrl: '',
      returnUrl: response.data,
    };
  } catch (err) {
    return filterExceptionMessage(parseError(err));
  }
};

export const addUPSMerchantAccount = async (
  code: string,
): Promise<{
  data?: CarrierAccountResponseType
} & GlobalResponseType> => {
  try {
    const response: AxiosResponse = await axiosService.post(
      `/my-accounts/ups-merchant-registration/${code}`,
    );

    return {
      successful: true,
      errorMessage: '',
      redirectUrl: '',
      data: response.data,
    };
  } catch (err) {
    return filterExceptionMessage(parseError(err));
  }
};
